<template>
    <div class="bookmark-frame" @click="toggle(jobId)">
        <i class="vs-icon notranslate icon-scale feather icon-custom-bookmark" :class="{'icon-filled': isActive}"></i>
    </div>
</template>
<script type="text/javascript">

    export default{
        
        data : function () {
        return {
            isActive: false,
        }
    },
    props:{
        jobId : Number
    },
    methods : {
        toggle: function( jobId ){

            let bookMarkedJobs = JSON.parse(localStorage.getItem('bookMarkedJobs')) || [];

            if (bookMarkedJobs.indexOf(jobId) > -1) bookMarkedJobs.splice(bookMarkedJobs.indexOf(jobId), 1);
            else bookMarkedJobs.push(jobId);

            localStorage.setItem('bookMarkedJobs', JSON.stringify(bookMarkedJobs));

            this.changeColor(jobId);
        },
        changeColor: function( jobId ){

            let bookMarkedJobs = JSON.parse(localStorage.getItem('bookMarkedJobs')) || [];

            bookMarkedJobs.indexOf(jobId) > -1 ? this.isActive = true : this.isActive = false;
        }
    },
    created() {
            this.changeColor(this.jobId);
    }
    }
</script>
